import React from 'react';
import { Highlight, Kicker, Squiggle } from './ui';

/*
 * Figma "Boxes" (node 35714:513): centred heading + three columns separated by
 * thin dividers at x=617 and x=1159 of the 1800px frame.
 */
const AudienceSection = ({ audience }) => (
  <section id="voor-wie" className="hp-container" data-testid="audience-section">
    <Squiggle className="mt-[clamp(32px,3.3889vw,61px)]" />
    <div className="mt-[clamp(32px,3.4444vw,62px)] text-center text-[#2b2b2b]">
      <Kicker>{audience.kicker}</Kicker>
      <h2 className="hp-h2-outfit mx-auto mt-[clamp(18px,1.3333vw,24px)] max-w-[9.86em]">
        <Highlight text={audience.title} />
      </h2>
    </div>

    <div className="mt-[clamp(40px,5.4444vw,98px)] grid grid-cols-1 gap-y-8 lg:min-h-[min(329px,18.2778vw)] lg:grid-cols-[504fr_542fr_529fr] lg:gap-y-0 lg:pl-[0.7222vw]">
      {audience.items.map((item, i) => (
        <div
          key={i}
          data-testid={`usecase-${i + 1}`}
          className={`${
            i > 0
              ? 'border-[#273947]/10 max-lg:border-t max-lg:pt-8 lg:border-l lg:pl-[clamp(20px,2.1111vw,38px)]'
              : ''
          } lg:pr-[clamp(16px,2.1111vw,38px)]`}
        >
          <span className="flex h-[clamp(64px,5vw,90px)] w-[clamp(64px,5vw,90px)] items-center justify-center rounded-full bg-brand-mint text-[clamp(34px,2.7778vw,50px)] font-bold leading-none text-[#263846]">
            {String(i + 1).padStart(2, '0')}
          </span>
          <h3 className="mt-[clamp(18px,1.4444vw,26px)] text-[clamp(28px,2.2222vw,40px)] font-bold leading-none text-[#263845]">
            <Highlight text={item.title} />
          </h3>
          <p className="mt-[clamp(14px,1.1111vw,20px)] max-w-[491px] text-[clamp(16px,1.3333vw,24px)] font-medium leading-[1.5833] text-[#263845]">
            {item.text}
          </p>
        </div>
      ))}
    </div>
  </section>
);

export default AudienceSection;
